import { useContext } from 'react';

import { CalendarMoveRecordContext } from '@app/providers/CalendarProvider/CalendarMoveRecordContext';
import { CalendarSettingsContext } from '@app/providers/CalendarProvider/CalendarSettingsContext';
import { IndividualCalendarContext } from '@app/providers/CalendarProvider/IndividualCalendarContext';
import { TeamCalendarContext } from '@app/providers/CalendarProvider/TeamCalendarContext';

export const useCalendarSettingsContext = () =>
  useContext(CalendarSettingsContext);

export const useTeamCalendarContext = () => useContext(TeamCalendarContext);

export const useIndividualCalendarContext = () =>
  useContext(IndividualCalendarContext);

export const useCalendarMoveRecordContext = () =>
  useContext(CalendarMoveRecordContext);
